import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { CardView, rem } from 'design-system';
import { buildDisputeFormHtml, getDisputeUrl } from '../utils/dispute';
const INITIAL_HEIGHT = rem(600);
// We can't inspect TU's page (cross-origin), so accept height postMessages
// from their hosted origins only.
const TU_ALLOWED_ORIGINS = new Set([
    'https://www.callcreditreport.co.uk',
    'https://ct.callcreditreport.co.uk',
]);
const DisputeIframe = ({ formFields }) => {
    const [height, setHeight] = useState(INITIAL_HEIGHT);
    // The auto-submitting form lives inside the iframe's own document (same
    // pattern as the native WebView flow), so the POST only fires once that
    // document has fully parsed — no race against the iframe's initial
    // about:blank load, which intermittently cancelled a form.submit() targeted
    // at the frame by name. The TU token is single-use, so the document is
    // captured once per mount and never regenerated: re-renders can't re-POST.
    // A new token (item change / retry) unmounts and remounts this component.
    const [html] = useState(() => buildDisputeFormHtml({ url: getDisputeUrl(), fields: formFields }));
    useEffect(() => {
        if (typeof window === 'undefined')
            return undefined;
        const win = window;
        const handler = (event) => {
            if (!TU_ALLOWED_ORIGINS.has(event.origin))
                return;
            const { data } = event;
            let next = null;
            if (typeof data === 'number' && data > 0) {
                next = data;
            }
            else if (data &&
                typeof data.height === 'number') {
                next = data.height;
            }
            if (next && next > 0)
                setHeight(next);
        };
        win.addEventListener('message', handler);
        return () => win.removeEventListener('message', handler);
    }, []);
    return (<CardView noMarginTop style={styles.container}>
      <View style={[styles.frameWrapper, { height }]}>
        <iframe srcDoc={html} title="TransUnion dispute" style={iframeStyle}/>
      </View>
    </CardView>);
};
export default DisputeIframe;
const iframeStyle = {
    border: 'none',
    width: '100%',
    height: '100%',
    backgroundColor: 'transparent',
};
const styles = StyleSheet.create({
    container: {
        marginHorizontal: rem(16),
    },
    frameWrapper: {
        width: '100%',
        minHeight: INITIAL_HEIGHT,
        paddingHorizontal: rem(16),
        paddingVertical: rem(32),
    },
});
